import React from "react";

import {
  GelDropDownQuestion
} from "@learningblocks/exp-components";

import "./style.scss";

export class GelDropDown extends React.Component {

  render() {
    return (
      <div style={{marginBottom: "20px"}}>
        <GelDropDownQuestion
          {...this.props}
          submitBtnText={"Submit answer"}
        />
      </div>
    );
  }
}
